// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"1fd05948","821":"7b3b2b1a"}[chunkId] + ".chunk.js";
};